<template>
  <div>
    <a-navigation id="atom-main-navigation" />
    <v-app id="app">
      <v-app-bar
        id="app-header"
        class="app-bar"
        :class="{ 'mobile-app-bar': isMobile }"
        app
        flat
        clipped-left
        short
      >
        <a-logo />
        <a-metalink-navigation />
      </v-app-bar>
      <vue-snotify />
      <v-main
        id="atom-main"
        :class="{ 'navigation-opened': !isNavigationCollapsed }"
      >
        <v-container
          id="atom-main-container"
          class="py-0 pr-0"
          :class="getMainContainerClass($route)"
          fluid
        >
          <a-loader v-if="isLoading" />
          <h1 v-if="$route.meta.title" v-t="$route.meta.title" />
          <router-view />
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import ANavigation from "+/components/navigation/Navigation";
import AMetalinkNavigation from "+/components/navigation/metalinkNavigation/MetalinkNavigation";
import Logo from "+/components/navigation/logo/Logo";
import Loader from "+/components/loader/Loader.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "a-navigation": ANavigation,
    "a-metalink-navigation": AMetalinkNavigation,
    "a-logo": Logo,
    "a-loader": Loader
  },
  data: () => ({
    closed: true
  }),
  computed: {
    ...mapGetters("loader", ["isLoading"]),
    ...mapGetters("menu", ["isNavigationCollapsed"]),
    ...mapGetters("dom", ["isMobile"])
  },
  meta() {
    return {
      title: this.$t(this.$route.meta.title)
    };
  },
  mounted() {
    this.setMobileState();
    window.addEventListener("resize", () => {
      this.setMobileState();
    });
  },
  methods: {
    ...mapActions("dom", ["setIsMobile"]),
    ...mapActions("mainIframeStore", ["setMainNavigationWidth"]),
    setMobileState() {
      this.setIsMobile(window.innerWidth < 900);
    },
    getMainContainerClass(route) {
      return this.isPersisMainRoute(route)
        ? "fusion-main-container-padding"
        : "atom-main-container-padding";
    },
    isPersisMainRoute(route) {
      const routeName = route.name;
      return (
        routeName === "mainFnAction" ||
        routeName === "mainFn" ||
        routeName === "main"
      );
    },
    navigationToggle(event) {
      this.closed = event;
    },
    transitionend() {
      if (event.target) {
        const navigationWidth = event.target.clientWidth;
        this.setMainNavigationWidth(navigationWidth);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#atom-main {
  height: calc(100vh - 56px);
  width: calc(100vw - 56px);
  padding-top: 0px !important;
  margin-top: 56px;
  overflow: auto;
  @media screen and (max-width: 900px) {
    height: calc(100vh - 56px);
    width: calc(100vw);
    &.navigation-opened {
      margin-left: calc(25rem);
    }
  }
  @media screen and (min-width: 901px) {
    margin-left: 56px;
    &.navigation-opened {
      padding-left: calc(25rem - 56px) !important;
    }
  }
}

.nav {
  overflow: visible;
}

::v-deep .app-bar.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: var(--v-background-base, #fff);
  border-bottom: 2px solid;
  border-color: #c1c1c1;
  @media screen and (max-width: 900px) {
    &.mobile-app-bar {
      transition: background-color 500ms ease-in-out;
      color: var(--ci-alpha-color, #fff);
      background-color: var(--ci-alpha-bg, #d4003c);
      border-color: currentColor;
      .v-icon {
        color: var(--ci-alpha-color, #fff);
      }
    }
  }
}
</style>
